<template>
  <div>
    <b-row>
      <b-col>
        <RelatieOverview
          ref="relatieOverview" 
          :relatie="relatie" 
          :url="url" 
          :delete-option="true"
        />
      </b-col>
      <b-col>
        <gmap-map
          :center="{lat:52.520587,lng:4.788474}" 
          :zoom="10" 
          style="height: 400px"
        >
          <gmap-marker
            v-for="u in mappedUnits" 
            :key="u.Id"
            :position="u.Position"
            :label="u.Type"
            :title="u.Adres"
          />
        </gmap-map>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import * as VueGoogleMaps from "vue2-google-maps";
import RelatieOverview from "@/components/RelatieOverview.vue";
import Vue from "vue";
import UnitsFinancieel from '../../components/UnitsFinancieel.vue';
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAhzyq_4d1zZ5Tei6SyD62UbPAd8xRy-0Q",
  },
});

export default {
    name:  'RelatieDashboard',
    components: {
      RelatieOverview,
      UnitsFinancieel
    },
    mixins: [ serviceMixin ],
    props: {
        relatie: {
            type: Object,
            default: () => {}
        },
        url: {
          type:String,
          default: null
        }
    },
    data() {
        return {
          units: [],
          showModal: false
        }
    },
    computed: {
      mappedUnits: function() {
        return this.units.filter(u => { return u.Position && !isNaN(u.Position.lat) && !isNaN(u.Position.lng) })
      },
    },
    mounted() {
      this.getUnits();
    },
    methods: {
      getUnits() {
        var vm = this;
        this.get(`${this.url}/units`)
          .then(function(response) {
            vm.units = response.data.units;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
}
</script>